<template>
  <div>
    <commonChat :chatType="1"></commonChat>
  </div>
</template>

<script>
  import commonChat from '@/views/IM/model/commonChat.vue'

  export default {
    name: 'artificialChat',
    components: { commonChat},
  }
</script>
